export const statusColors = {
    active: 'success',
    sold: 'warning',
    expired: 'error',
};
